var map = {
	"./de.json": [
		5894,
		706
	],
	"./en.json": [
		4174
	],
	"./es.json": [
		6725,
		9069
	],
	"./fr.json": [
		4605,
		4261
	],
	"./it.json": [
		3672,
		7996
	],
	"./ja.json": [
		7980,
		7368
	],
	"./pt.json": [
		7741,
		9321
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1555;
module.exports = webpackAsyncContext;